import React from 'react';
import { Classes } from '@blueprintjs/core';
import classNames from 'classnames';

import { SPACE, ENTER, isKeyCodeOrKeyInList } from 'core/util/keyCodes';

const MenuItemLight = (props) => {
  const { active, children, className, disabled, onClick, style, role } = props;
  const ariaProps = {};
  if (role) {
    ariaProps.role = role;
  }
  return (
    <li
      {...ariaProps}
      tabIndex={disabled ? -1 : 0}
      className={classNames(className, Classes.MENU_ITEM, {
        [Classes.ACTIVE]: active,
        [Classes.DISABLED]: disabled
      })}
      onClick={disabled ? undefined : onClick}
      onKeyDown={(e) => {
        if (isKeyCodeOrKeyInList(e, [SPACE, ENTER]) && !disabled) {
          onClick(e);
        }
      }}
      style={style}
    >
      {children}
    </li>
  );
};

export default MenuItemLight;
